import React from 'react';
import { useSERPActions } from '~/core/state/actions/SERPActionsContext';
import { useSERPState } from '~/core/state/SERPStateContext';
import { SetResultLayoutParams } from '~/core/useSearchState';
import styles from './resultLayout.module.scss';

const ResultLayout: React.FC = () => {
    const state = useSERPState();
    const { setResultLayout } = useSERPActions();

    const handleChange = (newLayout: SetResultLayoutParams) => {
        if (newLayout === state.resultLayout) {
            return;
        }
        setResultLayout(newLayout);
    };

    return (
        <div className={styles.view}>
            <div className={styles.viewItem}>
                <input
                    readOnly
                    type="radio"
                    id="grid"
                    name="view"
                    value="grid"
                    onClick={() => handleChange('grid')}
                    checked={state.resultLayout === 'grid'}
                    className={styles.viewInput}
                />
                <label htmlFor="grid" className={styles.viewItemLabel}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                    >
                        <path d="M1 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zM1 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zM1 12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z" />
                    </svg>
                    <span className={styles.viewItemText}>Dlaždicové zobrazení</span>
                </label>
            </div>
            <div className={styles.viewItem}>
                <input
                    readOnly
                    type="radio"
                    id="rows"
                    name="view"
                    value="rows"
                    onClick={() => handleChange('rows')}
                    checked={state.resultLayout === 'rows'}
                    className={styles.viewInput}
                />
                <label htmlFor="rows" className={styles.viewItemLabel}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                    >
                        <path d="M1 2C1 1.73478 1.10536 1.48043 1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1H14C14.2652 1 14.5196 1.10536 14.7071 1.29289C14.8946 1.48043 15 1.73478 15 2V4C15 4.26522 14.8946 4.51957 14.7071 4.70711C14.5196 4.89464 14.2652 5 14 5H2C1.73478 5 1.48043 4.89464 1.29289 4.70711C1.10536 4.51957 1 4.26522 1 4V2ZM1 7C1 6.73478 1.10536 6.48043 1.29289 6.29289C1.48043 6.10536 1.73478 6 2 6H14C14.2652 6 14.5196 6.10536 14.7071 6.29289C14.8946 6.48043 15 6.73478 15 7V9C15 9.26522 14.8946 9.51957 14.7071 9.70711C14.5196 9.89464 14.2652 10 14 10H2C1.73478 10 1.48043 9.89464 1.29289 9.70711C1.10536 9.51957 1 9.26522 1 9V7ZM1 12C1 11.7348 1.10536 11.4804 1.29289 11.2929C1.48043 11.1054 1.73478 11 2 11H14C14.2652 11 14.5196 11.1054 14.7071 11.2929C14.8946 11.4804 15 11.7348 15 12V14C15 14.2652 14.8946 14.5196 14.7071 14.7071C14.5196 14.8946 14.2652 15 14 15H2C1.73478 15 1.48043 14.8946 1.29289 14.7071C1.10536 14.5196 1 14.2652 1 14V12Z" />
                    </svg>
                    <span className={styles.viewItemText}>Řádkové zobrazení</span>
                </label>
            </div>
        </div>
    );
};

export default ResultLayout;
